import { ClowncarHeader } from 'components';
import { NewRouterRoot } from 'tools/root';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { StoreType } from 'utils/connect';
import { hasEngRoleSelector } from 'selectors/rolesSelectors';
import { useSelector } from 'react-redux';
import ClowncarBody from 'components/ClowncarBody';
import ClowncarMenu, { ClowncarMenuSections } from 'components/menu/ClowncarMenu';
import LogoutRoute from 'routes/logged-in/LogoutRoute';
import NotFoundRedirect from 'routes/NotFoundRedirect';
import ProtectedRoute from 'routes/ProtectedRoute';
import TockLoggedInRoute from 'routes/TockLoggedInRoute';

const SelectRoute: React.FunctionComponent<{}> = () => {
  const isEng = useSelector(hasEngRoleSelector);
  const sections = (): ClowncarMenuSections => {
    return {
      jce: [
        {
          exact: false,
          text: 'Admin tools',
          // /users comes up first, but then the user can switch to something else within JCE instead
          to: '/users',
          hide: !isEng,
        },
      ],
      tock: [
        {
          exact: false,
          text: 'Tock admin',
          to: '/tock',
        },
      ],
    };
  };
  const isAuthenticated = !!useSelector((state: StoreType) => state.app.jwtToken);
  const path = useHistory();

  if (path.location.pathname === '/') {
    // Non-eng users don't have a "select app" page — send them straight to tock
    if (!isEng) {
      return <Redirect to="/tock" />;
    }
    return (
      <div className="Clowncar">
        <ClowncarMenu sections={sections()} />
        <div className="Content">
          <ClowncarHeader heading="Select admin tool" />
          <div className="Main">
            <ClowncarBody isLoading={false}>
              <div>Select an app from the left menu item to access their respective tools</div>
            </ClowncarBody>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Switch>
      {/* /logout is a global route — handled here since TockLoggedInRoute is now scoped to /tock */}
      <Route component={LogoutRoute} path="/logout" />
      {/* Legacy v5 routes — stays here until fully migrated */}
      <ProtectedRoute
        component={TockLoggedInRoute}
        protection={{
          requireThat: isAuthenticated,
          elseRedirectTo: '/login',
        }}
        path="/tock"
      />
      {/* Catch-all for new v7 routes — add new paths to new_app_root.tsx, not here */}
      {isEng && (
        <ProtectedRoute
          component={NewRouterRoot}
          protection={{
            requireThat: isAuthenticated,
            elseRedirectTo: '/login',
          }}
        />
      )}
      {/* Non-eng users have no catch-all above — redirect to tock default rather than white screen */}
      {!isEng && (
        <Route>
          <NotFoundRedirect to="/tock" />
        </Route>
      )}
    </Switch>
  );
};

export default SelectRoute;
